import {
  Col,
  ColType,
  Crud,
  CrudAction,
  CrudOption,
  CrudApi,
  optionOf,
} from "../../comp/crud";
import {
  ApiClient,
  displayUserStatus,
  getUserStatusOpt,
} from "../../api/ApiClient";
import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Toast,
  Typography,
  Descriptions,
  Row,
  Col as RowCol,
  InputNumber,
  Tabs,
  TabPane,
  Checkbox,
} from "@douyinfe/semi-ui";
import { TextCell } from "../../comp/cell";
import {
  formatRelativeTime,
} from "../../utils";
import {IconModalStroked, IconUser, IconBookOpenStroked} from "@douyinfe/semi-icons";
import ContactsSideSheet from "../../comp/ContactsSideSheet";



export default function User() {
  const [totpQr, setTotpQr] = useState(undefined as undefined | string);
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
  const [showContacts, setShowContacts] = useState(false);
  const [statData, setStatData] = useState([{ key: "", value: "统计" }]);
  const [statDataObj, setStatDataObj] = useState([] as any);
  const [statLoading, setStatLoading] = useState(false);

  let apiClient = ApiClient.getDefault();
  let createUserPri = false;
  const role = localStorage.getItem("role");
  if ( role == "root" || role == "op_manager" || role == "quzhang" || role == "monitor") {
    createUserPri = true;
  } else {
    createUserPri = false;
  }

  let cols: Col[] = [
    {
      name: "ID",
      key: "id",
      hideInList: true,
      type: ColType.STRING,
    },
    {
      name: "用户名",
      key: "username",
      hideInList: true,
      hideInCreate: true,
      hideInEdit: true,
      type: ColType.STRING,
    },

    {
      name: "姓名",
      key: "name",
      showInFilter: true,
      type: ColType.STRING,
      width: 100,
    },
    {
      name: "城市",
      key: "city",
      type: ColType.SELECT,
      showInFilter: true,
      getOptions: (row) => apiClient.getDictAsOpts("city"),
    },
    {
      name: "手机号",
      key: "mobile",
      showInFilter: true,
      type: ColType.STRING,
    },
   
    {
      name: "角色",
      key: "roleName",
      type: ColType.SELECT,
      hideInEdit: true,
      hideInCreate: true,
    },
    {
      name: "团队",
      key: "teamId",
      type: ColType.TREE,
      getOptions: (row) => apiClient.getTeamAsOpts(),
      hideInList: true,
      showInFilter: true,
    },
    {
      name: "团队",
      key: "teamName",
      type: ColType.STRING,
      hideInEdit: true,
      hideInCreate: true,
    },
    {
      name: "上级",
      key: "managerName",
      type: ColType.STRING,
      hideInEdit: true,
      hideInCreate: true,
    },
    {
      name: "上级",
      key: "managerId",
      type: ColType.SELECT,
      optional: true,
      getOptions: (row) => apiClient.getUserAsOpts(),
      hideInList: true,
    },

    {
      name: "客户分值上限",
      key: "leadsScoreCap",
      optional: true,
      hideInList: true,
      hideInCreate: true,
      hideInEdit: true,
      type: ColType.NUMBER,
    },
    {
      name: "今日新客户数",
      optional: true,
      key: "todayLeads",
      hideInCreate: true,
      hideInEdit: true,
      type: ColType.NUMBER,
    },
    {
      name: "每日新客户数上限",
      optional: true,
      key: "leadsDailyCap",
      type: ColType.NUMBER,
      render: (a, b) => (
        <InputNumber
          style={{ width: "100px" }}
          formatter={(value) => `${value}`.replace(/\D/g, "")}
          value={b.leadsDailyCap}
          onBlur={(e) => handleLeadsDailyCapBlur(b, e.target.value)}
        />
      ),
    },
    {
      name: "总客户数",
      optional: true,
      key: "totalLeads",
      hideInCreate: true,
      hideInEdit: true,
      type: ColType.NUMBER,
    },
    // {
    //   name: "总客户数上限",
    //   optional: true,
    //   key: "leadsTotalCap",
    //   type: ColType.NUMBER,
    // },
    // {
    //   name: "接单状态",
    //   key: "available",
    //   type: ColType.SELECT,
    //   showInFilter: true,
    //   hideInList:true,
    //   getOptions: () => getAvailableOpts(),
    // },
    // {
    //   name: "接单状态",
    //   key: "available",
    //   type: ColType.STRING,
    //   showInFilter: false,
    //   render: (a, b) => (
    //     <Checkbox
    //       defaultChecked={a}
    //       onChange={() => handleCheckboxClick(b.id, !b.available)}
    //     />
    //   ),
    // },
    {
      name: "密码",
      hideInList: true,
      key: "password",
      type: ColType.STRING,
      hideInEdit: true,
    },
    {
      name: "密码",
      hideInList: true,
      key: "password",
      type: ColType.STRING,
      hideInCreate: true,
      optional: true,
      placeHolder: "留空不更新",
    },
    {
      name: "验证器",
      key: "totp",
      type: ColType.STRING,
      hideInCreate: true,
      hideInEdit: true,
      hideInList: true,
      optional: true,
      render: (a) => (a ? "已绑定" : "未绑定"),
    },
    {
      name: "状态",
      key: "status",
      type: ColType.SELECT,
      showInFilter: true,
      render: (v, i) => displayUserStatus(v),
      getOptions: (row) => {
        return Promise.resolve(getUserStatusOpt());
      },
    },
    {
      name: "入职时间",
      key: "entryAt",
      hideInCreate: true,
      hideInEdit: true,
      showInFilter: false,
      type: ColType.DATE_RANGE,
      render: (a: any) => <TextCell text={formatRelativeTime(a)} width={150} />,
    }
  ];

  let colEnable: Col[] = cols.slice(0, 4)
                   .concat([{
      name: "角色",
      key: "role",
      type: ColType.SELECT,
      hideInList: true,
      showInFilter: true,
      getOptions: async () => {
        let roleResp = await apiClient.getAllRoles();
        return roleResp.data.records.filter((r)=>r.code!='root'&&r.code!='op_manager').map((r) => {
          return {
            label: r.name,
            value: r.code,
            key: r.code,
          };
        });
      },
      render: (value) => {
        return value.join(", ");
      },
    }]).concat(cols.slice(4));

    let colAgent: Col[] = cols.slice(0, 4)
                   .concat([{
      name: "角色",
      key: "role",
      type: ColType.SELECT,
      hideInList: true,
      showInFilter: false,
       getOptions: async () => {
        return  [{
            label: "按揭",
            value: "agent",
            key: "agent",
          },{
            label: "按揭主管",
            value: "agent_manager",
            key: "agent",
          }];
       
      },
     
    }]).concat(cols.slice(4));
    

    let colPaymentUser: Col[] = cols.slice(0, 4)
                   .concat([{
      name: "角色",
      key: "role",
      type: ColType.SELECT,
      hideInList: true,
      showInFilter: false,
      getOptions: async () => {
        return  [{
            label: "外部还款人",
            value: "paymentUser",
            key: "paymentUser",
          }];
       
      },
     
    },{
      name: "资金规模",
      key: "capitalScaleAmount",
      optional: true,
      hideInList: false,
      hideInCreate: false,
      hideInEdit: false,
      type: ColType.NUMBER,
    }]).concat(cols.slice(4));


  let colLeaves: Col[] = [
    {
      name: "ID",
      key: "id",
      hideInList: true,
      type: ColType.STRING,
    },
    {
      name: "用户名",
      key: "username",
      hideInList: true,
      hideInCreate: true,
      hideInEdit: true,
      type: ColType.STRING,
    },

    {
      name: "姓名",
      key: "name",
      showInFilter: true,
      type: ColType.STRING,
      width: 100,
    },
    {
      name: "城市",
      key: "city",
      type: ColType.SELECT,
      showInFilter: true,
      getOptions: (row) => apiClient.getDictAsOpts("city"),
    },
    {
      name: "手机号",
      key: "mobile",
      showInFilter: true,
      type: ColType.STRING,
    },
    {
      name: "角色",
      key: "role",
      type: ColType.MULTI_SELECT,
      hideInList: true,
      showInFilter: true,
      getOptions: async () => {
        let roleResp = await apiClient.getAllRoles();
        return roleResp.data.records.map((r) => {
          return {
            label: r.name,
            value: r.code,
            key: r.code,
          };
        });
      },
      render: (value) => {
        return value.join(", ");
      },
    },
    {
      name: "角色",
      key: "roleName",
      type: ColType.SELECT,
      hideInEdit: true,
      hideInCreate: true,
    },
    {
      name: "团队",
      key: "teamId",
      type: ColType.TREE,
      getOptions: (row) => apiClient.getTeamAsOpts(),
      hideInList: true,
      showInFilter: true,
    },
    {
      name: "团队",
      key: "teamName",
      type: ColType.STRING,
      hideInEdit: true,
      hideInCreate: true,
    },
    {
      name: "上级",
      key: "managerName",
      type: ColType.STRING,
      hideInEdit: true,
      hideInCreate: true,
    },
    {
      name: "上级",
      key: "managerId",
      type: ColType.SELECT,
      optional: true,
      getOptions: (row) => apiClient.getUserAsOpts(),
      hideInList: true,
    },

    {
      name: "客户分值上限",
      key: "leadsScoreCap",
      optional: true,
      hideInList: true,
      hideInCreate: true,
      hideInEdit: true,
      type: ColType.NUMBER,
    },
    {
      name: "今日新客户数",
      optional: true,
      key: "todayLeads",
      hideInCreate: true,
      hideInEdit: true,
      type: ColType.NUMBER,
    },
    {
      name: "每日新客户数上限",
      optional: true,
      key: "leadsDailyCap",
      type: ColType.NUMBER,
    },
    {
      name: "总客户数",
      optional: true,
      key: "totalLeads",
      hideInCreate: true,
      hideInEdit: true,
      type: ColType.NUMBER,
    },
    // {
    //   name: "总客户数上限",
    //   optional: true,
    //   key: "leadsTotalCap",
    //   type: ColType.NUMBER,
    // },
    {
      name: "密码",
      hideInList: true,
      key: "password",
      type: ColType.STRING,
      hideInEdit: true,
    },
    {
      name: "密码",
      hideInList: true,
      key: "password",
      type: ColType.STRING,
      hideInCreate: true,
      optional: true,
      placeHolder: "留空不更新",
    },
    {
      name: "验证器",
      key: "totp",
      type: ColType.STRING,
      hideInCreate: true,
      hideInEdit: true,
      hideInList:true,
      optional: true,
      render: (a) => (a ? "已绑定" : "未绑定"),
    },
    {
      name: "状态",
      key: "status",
      type: ColType.SELECT,
      showInFilter: false,
      render: (v, i) => displayUserStatus(v),
      getOptions: (row) => {
        return Promise.resolve(getUserStatusOpt());
      },
    },
    {
      name: "离职时间",
      key: "leaveAt",
      hideInCreate: true,
      showInFilter: false,
      type: ColType.DATE_RANGE,
      render: (a: any) => <TextCell text={formatRelativeTime(a)} width={150} />,
    },
    {
      name: "入职时间",
      key: "entryAt",
      hideInCreate: true,
      hideInEdit: true,
      showInFilter: false,
      type: ColType.DATE_RANGE,
      render: (a: any) => <TextCell text={formatRelativeTime(a)} width={150} />,
    }
  ];

  const handleLeadsDailyCapBlur = async (user: any, leadsDailyCap: any) => {
    user.leadsDailyCap = leadsDailyCap;
    await apiClient
      .request("/users/updateDailyCap", "PUT", undefined, {
        id: user.id,
        leadsDailyCap: leadsDailyCap,
      })
      .then((res) => {
        if (res.code == "ok") {
          crudApi?.refresh();
          Toast.info("已更新");
        } else {
          Toast.info("更新失败");
        }
      });
  };

  useEffect(() => {
  }, []);

  useEffect(() => {
    //刷新统计
    initUserStatCountData();
  }, [statDataObj]);

  const genOtpAction: CrudAction = {
    name: "绑定验证器",
    action: async (a) => {
      await apiClient.request<string>(
        "/users/totp/" + a.id,
        "POST",
        undefined,
        undefined
      );
      Toast.info("已绑定");
      crudApi?.refresh();
    },
  };
  const leaveOtpAction: CrudAction = {
    name: "离职",
    action: async (a) => {
      Modal.confirm({
        title: "是否确认离职?",
        content: "",
        onOk: async () => {
          await apiClient.request("/users/updateStatus", "PUT", undefined, {
            id: a.id,
            status: "LEAVE",
          });
          Toast.info("操作成功，请在离职人员里查看");
          crudApi?.refresh();
        },
      });
    },
  };
  const enableOtpAction: CrudAction = {
    name: "入职",
    action: async (a) => {
      Modal.confirm({
        title: "是否确认入职?",
        content: "",
        onOk: async () => {
          await apiClient.request("/users/updateStatus", "PUT", undefined, {
            id: a.id,
            status: "ENABLED",
          });
          Toast.info("操作成功，请在在职人员里查看");
          crudApi?.refresh();
        },
      });
    },
  };
  const viewTotpQrAction: CrudAction = {
    name: "验证器二维码",
    action: async (a) => {
      const qr = await apiClient.request<string>(
        "/users/totpQr/" + a.id,
        "GET",
        undefined,
        undefined
      );
      setTotpQr(qr.data);
    },
  };
  const clearTotpAction: CrudAction = {
    name: "解绑验证器",
    action: async (a) => {
      await apiClient.request<string>(
        "/users/clearTotp/" + a.id,
        "POST",
        undefined,
        undefined
      );
      Toast.info("已解绑");
      crudApi?.refresh();
    },
  };
  const getRowActions = (a: any) => {
    if (a.totp) {
      return [leaveOtpAction, viewTotpQrAction, clearTotpAction];
    } else {
      return [leaveOtpAction];
    }
  };

  const initUserStatCountData = async () => {
    if (statDataObj.length == 0) {
      return;
    }

    const data = [
      { key: "", value: "统计" },
      { key: "在职用户", value: statDataObj.total },
      { key: "接单中", value: statDataObj.available },
      { key: "今日新客户数", value: statDataObj.todayLeads },
      {
        key: "每日新客户数上限",
        value: statDataObj.leadsDailyCap,
      },
      {
        key: "总客户数",
        value: statDataObj.totalLeads,
      },

    ];
    setStatData(data);
  };

  const queryUserStatCount = async (data: any) => {
    setStatLoading(true);
    let params = {
      ...data,
    };
    console.log("统计报表查询参数：", params);

    apiClient.getUserStat(params).then((resp) => {
      setStatLoading(false);
      setStatDataObj(resp.data);
    });

  };

  const userStat = () => {
    const style = {
      boxShadow: "var(--semi-shadow-elevated)",
      backgroundColor: "var(--semi-color-bg-2)",
      borderRadius: "4px",
      padding: "10px",
      margin: "auto",
    };
    return (
      <div style={{ display: "flex", width: "100%", margin: "5px" }}>
        <Descriptions data={statData} row style={style} />
      </div>
    );
  };

  const getAvailableOpts = async (): Promise<CrudOption[]> => {
    const sourceVisible: any = [
      {
        label: "接单",
        value: 1,
        key: 1,
      },
      {
        label: "未接单",
        value: 0,
        key: 0,
      },
    ];
    return sourceVisible;
  };

  const handleCheckboxClick = async (id: any, available: any) => {
    await apiClient.request("/teamMember/availability", "PUT", undefined, {
      id: id,
      available: available,
    });
    Toast.info("已更新");
    crudApi?.refresh();
  };

  return (
    <>
     
      <ContactsSideSheet visible={showContacts} onClose={() => setShowContacts(false)} />
      <Modal
          icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }}/>}
        visible={totpQr != undefined}
        onCancel={() => setTotpQr(undefined)}
        onOk={() => setTotpQr(undefined)}
      >
        <div style={{ textAlign: "center" }}>
          <p>
            <img width={200} src={totpQr} />
          </p>
          <p>
            各大应用商店搜索【腾讯身份验证器】，安装后扫描二维码绑定验证器。
          </p>
          <p>绑定后，每次登录需要输入验证器上的6位随机密码</p>
        </div>
      </Modal>

     
      <Tabs type="line" style={{ margin: 10 }} tabBarExtraContent={
            <Button icon={<IconBookOpenStroked />}
                onClick={() => setShowContacts(true)}
            >
                查看通讯录
            </Button>
        }>
        <TabPane
          tab={
            <span>
              <IconUser />
              在职人员
            </span>
          }
          itemKey="1"
        >
           {userStat()}
          <Crud
            getCrudApi={(api) => setCrudApi(api)}
            fetchDataAfterMethod={queryUserStatCount}
            getRowActions={getRowActions}
            canUpdate={createUserPri}
            canCreate={createUserPri}
            name="在职人员"
            entityKey="users"
            pageSize={50}
            cols={colEnable}
          />
        </TabPane>
        <TabPane
          tab={
            <span>
              <IconUser />
              离职人员
            </span>
          }
          itemKey="2"
        >
          <Crud
            getRowActions={(a: any) => {
              return [enableOtpAction];
            }}
            getCrudApi={(api) => setCrudApi(api)}
            canUpdate={false}
            canCreate={false}
            params={{ status: "LEAVE" }}
            initFilterValues={{ status: "LEAVE" }}
            name="离职人员"
            entityKey="users"
            pageSize={50}
            cols={colLeaves}
          />
        </TabPane>

          <TabPane
          tab={
            <span>
              <IconUser />
              按揭人员
            </span>
          }
          itemKey="3"
        >
          <Crud
            getCrudApi={(api) => setCrudApi(api)}
            getRowActions={getRowActions}
            canUpdate={createUserPri}
            canCreate={createUserPri}
            params={{ role: ["agent","agent_manager"] }}
            initFilterValues={{ role: ["agent","agent_manager"] }}
            name="按揭人员"
            entityKey="users"
            pageSize={50}
            cols={colAgent}
          />
        </TabPane>

          <TabPane
          tab={
            <span>
              <IconUser />
              外部还款人
            </span>
          }
          itemKey="4"
        >
          <Crud
            getCrudApi={(api) => setCrudApi(api)}
            getRowActions={getRowActions}
            canUpdate={createUserPri}
            canCreate={createUserPri}
            params={{ role: ["paymentUser"] }}
            initFilterValues={{ role: ["paymentUser"] }}
            name="外部还款人"
            entityKey="users"
            pageSize={50}
            cols={colPaymentUser}
          />
        </TabPane>

      </Tabs>
    </>
  );
}
